import React from 'react'

import { Dimmer, Loader, Feed, Icon, Breadcrumb } from 'semantic-ui-react';
import { InfosBar } from 'components';

import { Typeof } from 'utils';

import { API } from 'services';

import moment from 'moment';

import './style.css';

class ActivityFeed extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      events: [],
      refresh: true,
      max: props.max
    };

    this.handleRefresh = this.handleRefresh.bind(this);
    this.onRefresh = this.onRefresh.bind(this);

    this.handleShowMore = this.handleShowMore.bind(this);
    this.handleShowAll = this.handleShowAll.bind(this);
  }

  componentDidMount() {
    this.onRefresh();
  }

  componentDidUpdate(prevProps, prevState) {

    if(prevProps.filter !== this.props.filter) {
      this.handleRefresh();
    }

    if(!prevState.refresh && this.state.refresh) {
      this.onRefresh();
    }
  }

  handleRefresh() {
    this.setState({
      refresh: true
    });
  }

  onRefresh() {

    let params = {};

    //Limit
    if(Typeof.number(this.state.max) && this.state.max > 0) {
      params.limit = this.state.max;
    }

    //Type
    if(this.props.filter !== ActivityFeed.FILTER_NONE) {
      params.type = this.props.filter;
    }

    API.get(`${this.props.route}${API.queryParams(params)}`)
      .then((response) => {

        let events = response.data.map((event) => {

          let entry = this.props.mapping.entries.find((entry) => { return entry.type === event.type });

          let icon = 'help';
          let content = `Événement '${event.type}' inconnu`;
          let extra = null;

          if(Typeof.object(entry)) {

            let data = entry.content(event.data);

            if(data.icon) {
              icon = data.icon
            }

            if(data.content) {
              content = data.content;
            }

            if(data.extra) {
              extra = (
                <span className="extra">
                  {data.extra}
                </span>
              );
            }
          }

          return {
            icon: icon,
            timestamp: moment(event.timestamp).format('[Le] DD/MM/YYYY [à] HH:mm:ss'),
            summary: [content, extra]
          };
        });

        console.log(events);

        this.setState({
          events: events,
          refresh: false
        })

      });
  }

  handleShowMore() {

    this.setState({
      refresh: true,
      max: this.state.max + this.props.max
    });
  }

  handleShowAll() {

    this.setState({
      refresh: true,
      max: undefined
    });
  }

  render() {

    let events = this.state.events;

    return (
      <React.Fragment>

        {/* Events */}
        {events.length > 0 ? (

          <React.Fragment>

            <Feed>

              {/* Events */}
              {events.map((event, index) => {

                return (
                  <Feed.Event key={index}>

                    {/* Icon */}
                    <Feed.Label>

                      {Typeof.string(event.icon) ? (
                        <Icon name={event.icon} />
                      ) : (
                        event.icon
                      )}

                    </Feed.Label>

                    <Feed.Content>

                      {/* Timestamp */}
                      <Feed.Date>{event.timestamp}</Feed.Date>

                      {/* Summary */}
                      <Feed.Summary>{event.summary}</Feed.Summary>
                    </Feed.Content>

                  </Feed.Event>
                );
              })}

            </Feed>

            {/* Actions */}
            <InfosBar mode="row">
              <Breadcrumb>
                <Breadcrumb.Section link onClick={this.handleShowMore}>Voir plus</Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section link onClick={this.handleRefresh}>Actualiser</Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section link onClick={this.handleShowAll}>Voir tout</Breadcrumb.Section>
              </Breadcrumb>
            </InfosBar>

          </React.Fragment>

        ) : (
          <InfosBar mode="row">
            <span>Aucune activité récente</span>
            <Breadcrumb>
              <Breadcrumb.Section link onClick={this.handleRefresh}>Actualiser</Breadcrumb.Section>
            </Breadcrumb>
          </InfosBar>
        )}

        {/* Dimmer */}
        {this.state.refresh &&
          <Dimmer active inverted>
            <Loader inverted content="Actualisation..." />
          </Dimmer>
        }

      </React.Fragment>
    );
  }
}

//--Constants

ActivityFeed.FILTER_NONE = '~none~';

ActivityFeed.Mapping = (entries) => {

  return {
    entries: entries,
    getFilters: () => {

      let filters = [];

      //All
      filters.push({
          key: 0,
          text: 'Tout',
          value: ActivityFeed.FILTER_NONE
      });

      entries.forEach((entry, i) => {

        filters.push({
          key: i + 1,
          text: entry.name,
          value: entry.type
        });

      });

      return filters;
    }
  }

};

export default ActivityFeed;
